import CrudModel from './CrudModel';
import { DEFAULT_DECIMALS, DECIMAL_TYPES } from 'utils/decimal/constants';

export default class CompanySettingsModel extends CrudModel {
    constructor(entity) {
        const decimalDefaults = {
            intdecimalscurrencygeneral: DEFAULT_DECIMALS[DECIMAL_TYPES.CURRENCY_GENERAL],
            intdecimalscurrencyprices: DEFAULT_DECIMALS[DECIMAL_TYPES.CURRENCY_PRICES],
            intdecimalsquantity: DEFAULT_DECIMALS[DECIMAL_TYPES.QUANTITY],
            intdecimalsgeneral: DEFAULT_DECIMALS[DECIMAL_TYPES.GENERAL],
        };
        if (!entity) {
            entity = {
                name: '',
                vatnumber: '',
                phone: '',
                adressline1: '',
                adressline2: '',
                town: '',
                region: '',
                country: '',
                legaltext: '',
                reportimage: '',
                companyimage: '',
                isdefaultenvironment: 0,
                idcurrency: '',
                units: 0,
                ...decimalDefaults,
            };
        } else if (entity.newEntity) {
            delete entity.newEntity;
            entity = {
                ...entity,
                ...{
                    name: '',
                    vatnumber: '',
                    phone: '',
                    adressline1: '',
                    adressline2: '',
                    town: '',
                    region: '',
                    country: '',
                    legaltext: '',
                    reportimage: '',
                    companyimage: '',
                    isdefaultenvironment: 0,
                    idcurrency: '',
                    units: 0,
                    ...decimalDefaults,
                },
            };
        } else {
            // Normalize API camelCase decimal fields to lowercase for form binding
            if (entity.intDecimalsCurrencyGeneral !== undefined) {
                entity.intdecimalscurrencygeneral = entity.intDecimalsCurrencyGeneral;
            }
            if (entity.intDecimalsCurrencyPrices !== undefined) {
                entity.intdecimalscurrencyprices = entity.intDecimalsCurrencyPrices;
            }
            if (entity.intDecimalsQuantity !== undefined) {
                entity.intdecimalsquantity = entity.intDecimalsQuantity;
            }
            if (entity.intDecimalsGeneral !== undefined) {
                entity.intdecimalsgeneral = entity.intDecimalsGeneral;
            }
        }
        super(entity);
        this.entity.countryName = '';
    }

    get save() {
        const entity = this.entity;
        const crud = {
            name: entity.name,
            vatNumber: entity.vatnumber,
            phone: entity.phone,
            adressLine1: entity.adressline1,
            adressLine2: entity.adressline2,
            town: entity.town,
            region: entity.region,
            country: Number(entity.country),
            legalText: entity.legaltext,
            reportImage: entity.reportimage,
            companyImage: entity.companyimage,
            isDefault: entity.isdefaultenvironment,
            currency:
                entity.idcurrency != null && entity.idcurrency !== ''
                    ? Number(entity.idcurrency)
                    : 0,
            imperialSystem: entity.units != null && entity.units !== '' ? Number(entity.units) : 0,
            intDecimalsCurrencyGeneral:
                entity.intdecimalscurrencygeneral != null &&
                entity.intdecimalscurrencygeneral !== ''
                    ? Number(entity.intdecimalscurrencygeneral)
                    : DEFAULT_DECIMALS[DECIMAL_TYPES.CURRENCY_GENERAL],
            intDecimalsCurrencyPrices:
                entity.intdecimalscurrencyprices != null && entity.intdecimalscurrencyprices !== ''
                    ? Number(entity.intdecimalscurrencyprices)
                    : DEFAULT_DECIMALS[DECIMAL_TYPES.CURRENCY_PRICES],
            intDecimalsQuantity:
                entity.intdecimalsquantity != null && entity.intdecimalsquantity !== ''
                    ? Number(entity.intdecimalsquantity)
                    : DEFAULT_DECIMALS[DECIMAL_TYPES.QUANTITY],
            intDecimalsGeneral:
                entity.intdecimalsgeneral != null && entity.intdecimalsgeneral !== ''
                    ? Number(entity.intdecimalsgeneral)
                    : DEFAULT_DECIMALS[DECIMAL_TYPES.GENERAL],
        };
        return crud;
    }

    get id() {
        return this.entity.id;
    }

    get name() {
        return this.entity.name;
    }

    get vatnumber() {
        return this.entity.vatnumber;
    }

    get phone() {
        return this.entity.phone;
    }

    get address1() {
        return this.entity.adressline1;
    }

    get address2() {
        return this.entity.adressline2;
    }

    get city() {
        return this.entity.town;
    }

    get region() {
        return this.entity.region;
    }

    get idCountry() {
        return this.entity.country;
    }

    get countryName() {
        return this.entity.countryName;
    }

    get legaltext() {
        return this.entity.legaltext;
    }

    get reportimg() {
        return this.entity.reportimage && this.entity.reportimage !== ''
            ? `data:image/png;base64,${this.entity.reportimage}`
            : null;
    }

    get companyimg() {
        return this.entity.companyimage && this.entity.companyimage !== ''
            ? `data:image/png;base64,${this.entity.companyimage}`
            : null;
    }

    get idEnvironment() {
        return this.entity.idenvironment;
    }

    get environmentName() {
        return this.entity.environmentname;
    }

    set name(str) {
        this.entity.name = str;
    }

    set vatnumber(str) {
        this.entity.vatnumber = str;
    }

    set phone(str) {
        this.entity.phone = str;
    }

    set address1(str) {
        this.entity.adressline1 = str;
    }

    set address2(str) {
        this.entity.adressline2 = str;
    }

    set city(str) {
        this.entity.town = str;
    }

    set region(str) {
        this.entity.region = str;
    }

    set idCountry(id) {
        this.entity.country = id;
    }

    set countryName(str) {
        this.entity.countryName = str;
    }

    set legaltext(str) {
        this.entity.legaltext = str;
    }

    set reportimg(str) {
        this.entity.reportimage = str;
    }

    set companyimg(str) {
        this.entity.companyimage = str;
    }

    set environmentName(str) {
        this.entity.environmentname = str;
    }

    set idEnvironment(str) {
        this.entity.idenvironment = parseInt(str);
    }

    get idcurrency() {
        return this.entity.idcurrency;
    }

    set idcurrency(value) {
        this.entity.idcurrency = value;
    }

    get currencyname() {
        return this.entity.currencyname;
    }

    set currencyname(value) {
        this.entity.currencyname = value;
    }

    get units() {
        return this.entity.units;
    }

    set units(value) {
        this.entity.units = value;
    }

    get isDefaultEnvironment() {
        return this.entity.isdefaultenvironment;
    }

    set isDefaultEnvironment(value) {
        this.entity.isdefaultenvironment = value;
    }

    get intdecimalscurrencygeneral() {
        return this.entity.intdecimalscurrencygeneral;
    }

    set intdecimalscurrencygeneral(value) {
        this.entity.intdecimalscurrencygeneral = value;
    }

    get intdecimalscurrencyprices() {
        return this.entity.intdecimalscurrencyprices;
    }

    set intdecimalscurrencyprices(value) {
        this.entity.intdecimalscurrencyprices = value;
    }

    get intdecimalsquantity() {
        return this.entity.intdecimalsquantity;
    }

    set intdecimalsquantity(value) {
        this.entity.intdecimalsquantity = value;
    }

    get intdecimalsgeneral() {
        return this.entity.intdecimalsgeneral;
    }

    set intdecimalsgeneral(value) {
        this.entity.intdecimalsgeneral = value;
    }
}
